import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import back from '../Images/newArrow.svg';
import logoAuth from '../Images/logo.svg';
import styles from './ForgotPassword.module.css';
import { toast } from '../utils/sweetAlert.ts';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
function SignInFormPass() {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = async () => {
    const email = getValues().email.toLocaleLowerCase();

    const headersList = {
      Accept: '*/*',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    };
    let errorMessage = 'An unexpected error occurred';
    try {
        const response = await fetch(`${backendUrl}/forgot-password`, {
        method: 'POST',
        headers: headersList,
        body: JSON.stringify({
          email,
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        errorMessage = data.message || `HTTP error ${response.status}: ${response.statusText}`;
        throw new Error('HTTP error ' + response.status);
      }

      toast('success', data.message);
    } catch (error) {
      toast('error', errorMessage);
    }
  };

  return (
    <section className={styles.section}>
      <div className={styles.forgotPass}>
        <header>
          <div className={styles.logo}>
            <img src={logoAuth} alt="logo" className={styles.user_img} />
          </div>
          <p className={styles.heading}>Forgot password?</p>
          <p className={styles.subHeading}>No worries, we'll send you reset instructions.</p>
        </header>

        <form onSubmit={handleSubmit(onSubmit)}>
          <label className={styles.label} htmlFor="email">
            Email
          </label>
          <input
            className={errors?.email?.message ? styles.error_input : styles.input}
            placeholder="Enter your email"
            id="email"
            {...register('email', {
              required: 'This field is required',
              validate: {
                matchPattern: v =>
                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                  'Invalid email. Please enter your email in the format: name@example.com',
              },
            })}
          />
          {errors.email?.message && (
            <p className={styles.error}>{errors.email.message}</p>
          )}

          <div>
            <button className={styles.button}>Send</button>
          </div>

          <Link to="/sign-in" className={styles.backLink}>
            <div className={styles.back}>
              <img src={back} alt="back" />
              Back to login
            </div>
          </Link>
        </form>
      </div>
    </section>
  );
}

export {SignInFormPass};
